<template>
  <Teleport to="body">
    <div v-bind="toastApi.getGroupProps()">
      <Toast
        v-for="(toastItem, index) in toastApi.getToasts()"
        :key="toastItem.id"
        :actor="toastItem"
        :index="index"
        :parent="service"
      />
    </div>
  </Teleport>

  <slot />
</template>

<script lang="ts" setup>
import * as toast from '@zag-js/toast'
import { normalizeProps, useMachine } from '@zag-js/vue'
import { computed, defineAsyncComponent } from 'vue'

import { toaster } from '~/components/Toast/hooks'

const Toast = defineAsyncComponent(() => import('~/components/Toast/Toast.vue'))

const service = useMachine(toast.group.machine, { id: '1', store: toaster })
const toastApi = computed(() => toast.group.connect(service, normalizeProps))
</script>
